import { PhysicalAddress } from '@ally/transmitigator'

/**
 * Formats the physicalAddress returned from Transmit as:
 *
 * {Street address, City, State ZIP}
 */

export const formatAddress = (physicalAddress: PhysicalAddress): string => {
  const { street1, street2, city, state, postalCode } = physicalAddress
  const hasStreet2 = street2 && street2.length > 0
  const addressSegments = [`${street1}${hasStreet2 ? '' : ','}`]

  if (hasStreet2) {
    addressSegments.push(`${street2},`)
  }

  addressSegments.push(`${city},`)
  addressSegments.push(state)
  addressSegments.push(postalCode)

  return addressSegments.join(' ')
}
